module.exports = __webpack_public_path__ + "static/national-2-web-regular-12916766a8588f2b5c16d7136a699734.woff2";